import React, { useState } from "react";
import { Box, Card, Typography, Button } from "@mui/material";
import UpdatesTable from "./UpdatesTable";

const UpdatesCard = ({ updates }) => {
  const [showAll, setShowAll] = useState(false);

  const visibleUpdates = showAll ? updates : updates.slice(0, 5);

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 3,
        background: "rgba(255,255,255,0.9)",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
      }}
    >
      <Typography variant="h6" fontWeight={600} mb={2}>
        Recent Updates
      </Typography>

      <UpdatesTable updates={visibleUpdates} />

      {updates.length > 5 && (
        <Box mt={-.5} mb={-.5} textAlign="center">
          <Button
            onClick={() => setShowAll((p) => !p)}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "20px",
            }}
          >
            {showAll ? "Show Less" : "Show More"}
          </Button>
        </Box>
      )}
    </Card>
  );
};

export default UpdatesCard;
